import { lazy } from 'react';
import { Link, useSearchParams } from 'react-router';
const Banners = lazy(() => import('./PlatformAnnouncementsPage').then(m => ({default:m.PlatformAnnouncementsPage})));
const Updates = lazy(() => import('./PlatformUpdatesPage').then(m => ({default:m.PlatformUpdatesPage})));
export function CommunicationsPage() {
 const [params] = useSearchParams();
 const updates = params.get('view') === 'updates';
 return <div className="stack"><nav aria-label="Announcement type" className="row" style={{flexWrap:'wrap'}}>
 <Link className={`btn btn-sm ${!updates ? 'btn-primary' : 'btn-secondary'}`} aria-current={!updates ? 'page' : undefined} to="/platform/announcements">Announcements</Link>
 <Link className={`btn btn-sm ${updates ? 'btn-primary' : 'btn-secondary'}`} aria-current={updates ? 'page' : undefined} to="/platform/announcements?view=updates">Product updates</Link>
 </nav>{updates ? <Updates /> : <Banners />}</div>;
}
